import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';
import AnimateSection from '@/components/base/AnimateSection';

const hotAlbums = articles.slice(0, 4);

export default function HotAlbumsSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <AnimateSection>
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10 md:mb-12">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                {t('home.hotAlbums')}
              </h2>
              <p className="mt-2 text-sm text-foreground-600">
                {t('home.hotAlbumsDesc')}
              </p>
            </div>
            <Link
              to="/category"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              {t('home.allCategories')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </AnimateSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {hotAlbums.map((article, index) => (
            <AnimateSection key={article.id} delay={index * 120} animation="animate-fade-in">
              <Link
                to={`/article/${article.id}`}
                className="group bg-background-50 rounded-xl overflow-hidden hover:scale-[1.02] transition-all duration-400 cursor-pointer block"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={article.cover}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                    title={article.title}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400"></div>
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-primary-600">
                      {article.tags[0]}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors duration-300">
                    {article.title}
                  </h3>
                  <p className="mt-2 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                    {article.excerpt}
                  </p>
                  <div className="mt-3 flex items-center justify-between text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views.toLocaleString()}
                    </span>
                    <span>{article.date}</span>
                  </div>
                </div>
              </Link>
            </AnimateSection>
          ))}
        </div>
      </div>
    </section>
  );
}